/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SessionQuarantine = {
  /**
   * When the quarantine opened.
   */
  createdAt: Date;
  /**
   * The session quarantine ID.
   */
  id: string;
  /**
   * The organization ID.
   */
  organizationId: string;
  /**
   * The project ID.
   */
  projectId: string;
  /**
   * The deny reason captured when the quarantine opened.
   */
  reason: string;
  /**
   * When the quarantine was released.
   */
  releasedAt?: Date | undefined;
  /**
   * The user who released the quarantine.
   */
  releasedBy?: string | undefined;
  /**
   * The risk policy that opened the quarantine, when still available.
   */
  riskPolicyId?: string | undefined;
  /**
   * The risk policy name captured when the quarantine opened.
   */
  riskPolicyName: string;
  /**
   * The hook conversation ID that is quarantined.
   */
  sessionId: string;
  /**
   * The user whose hook event opened the quarantine.
   */
  userId: string;
};

/** @internal */
export const SessionQuarantine$inboundSchema: z.ZodMiniType<
  SessionQuarantine,
  unknown
> = z.pipe(
  z.object({
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    id: z.string(),
    organization_id: z.string(),
    project_id: z.string(),
    reason: z.string(),
    released_at: z.optional(
      z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ),
    released_by: z.optional(z.string()),
    risk_policy_id: z.optional(z.string()),
    risk_policy_name: z.string(),
    session_id: z.string(),
    user_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
      "organization_id": "organizationId",
      "project_id": "projectId",
      "released_at": "releasedAt",
      "released_by": "releasedBy",
      "risk_policy_id": "riskPolicyId",
      "risk_policy_name": "riskPolicyName",
      "session_id": "sessionId",
      "user_id": "userId",
    });
  }),
);

export function sessionQuarantineFromJSON(
  jsonString: string,
): SafeParseResult<SessionQuarantine, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SessionQuarantine$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SessionQuarantine' from JSON`,
  );
}
